import script from "./Line2FromCientosPackageAndItsTheSameButYouCanAlsoUseClippingPlanesSoItsNot.vue?vue&type=script&setup=true&lang=ts"
export * from "./Line2FromCientosPackageAndItsTheSameButYouCanAlsoUseClippingPlanesSoItsNot.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__